const forms = [
  {
    name: "Account Mapping",
    className: "bg-white p-8 rounded-md w-[100%] mx-auto",
    options: [
      {
        name: "Sales Account",
        type: "select",
        form: {
          name: "sales_account",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Select Sales Account",
          api: "get-all-accounts",
          source: "accountsMapping",
          options: null,
          value: null,
        },
      },
      {
        name: "Sales Return Account",
        type: "select",
        form: {
          name: "sales_return_account",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Select Sales Return Account",
          api: "get-all-accounts",
          source: "accountsMapping",
          options: null,
          value: null,
        },
      },
      {
        name: "Purchase Account",
        type: "select",
        form: {
          name: "purchase_account",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Select Purchase Account",
          api: "get-all-accounts",
          source: "accountsMapping",
          options: null,
          value: null,
        },
      },
      {
        name: "Purchase Return Account",
        type: "select",
        form: {
          name: "purchase_return_account",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Select Purchase Return Account",
          api: "get-all-accounts",
          source: "accountsMapping",
          options: null,
          value: null,
        },
      },
      {
        name: "Inventory Account",
        type: "select",
        form: {
          name: "inventory_account",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Select Inventory Account",
          api: "get-all-accounts",
          source: "accountsMapping",
          options: null,
          value: null,
        },
      },
    ],
  },
];

export default forms;